module.exports = __webpack_public_path__ + "media/photo/leadership-bb0fd1b1.jpg";